<template>
  <div class="pcproducts">
    <el-backtop target=".pcproducts"></el-backtop>
    <div class="pchome-headerpro">
      <headers @ChangeEmit="ChangeEmit" ref="head"></headers>
    </div>
    <div class="producthea">
      <div class="producthea-left">
        {{procenter}}
      </div>
    </div>
    <!--		<div class="linesd"></div>-->
    <!-- <div class="productfoo">
      <div class="productfoo-itmess" v-for="(item,index) in categorylistcontsecz" :key="index">
        <div class="productfoo-down" @click="proconblock(item.id)">
          <div></div>
          <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcproductimg/open.svg"  v-show="active_category == item.id"/>
          <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcproductimg/open.svg" v-show="active_category !== item.id" style="transform:scale(1,-1)" />
          {{item.name}}
        </div>
        <div class="productfoo-shop"  v-show="active_category == item.id">
          <div class="shop-item" v-for="(ite,inde) in lcategoryidlist" :key="inde" @click="detailto(ite.id)" v-if="ite.category_id==item.id">
            <div class="shopitem-img">
              <img :src="ite.rule_image" />
            </div>
            <div class="shopitem-model">{{ite.name}}</div>
            <div class="shopitem-title">{{ite.name_content}}</div>
          </div>
        </div>
      </div>
    </div> -->
    <div class="product-list-container">
      <div class="productfoo">
        <div v-for="(item,index) in categorylistcontsecz" :key="index" :id="'product_category'+item.id" style="padding-top:40px">
          <div class="productfoo-itmess" >
            <div class="productfoo-down" @click="proconblock(item.id)" >
              <div></div>
              <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcproductimg/open.svg"  v-if="item.mess1"/>
              <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcproductimg/open.svg" v-if="!item.mess1" style="transform:scale(1,-1)" />
              {{item.name}}
            </div>
            <div class="productfoo-shop"  v-if="item.mess1">
              <div class="shop-item" v-for="(ite,inde) in lcategoryidlist" :key="inde" @click="detailto(ite.id)" v-if="ite.category_id==item.id">
                <div class="shopitem-img">
                  <img :src="ite.rule_image" />
                </div>
                <div class="shopitem-model">{{ite.name}}</div>
                <div class="shopitem-title">{{ite.name_content}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footers ref=is_change></footers>
  </div>
</template>

<script>
import '@/lib-flexible/flexible.js'
import {session} from '../../storage/storage.js';
import headers from '../../common/header.vue'
import footers from '../../common/footers.vue'
export default{
  data(){
    return{
      id:'',
      procont:true,
      navheader:true,
      heshow:false,
      show: false,
      playli:true,
      playri:true,
      procenter:'产品中心',
      categorylist:[],
      categorylistcontsecz:[],
      lcategoryidlist:'',
      active_category:[],
      options: [{
        value: '选项1',
        label: '啄木鸟官网'
      }, {
        value: '选项2',
        label: '啄木鸟官网1'
      }, {
        value: '选项3',
        label: '啄木鸟官网2'
      }, {
        value: '选项4',
        label: '啄木鸟官网3'
      }, {
        value: '选项5',
        label: '啄木鸟官网4'
      }],
      optionslang: [{
        valuelang: '选项1',
        labellang: 'CN'
      }, {
        valuelang: '选项2',
        labellang: 'EN'
      }],
      value: '',
      valuelang: '',
      list_img: [
        //       { url: require("https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcproductimg/productin.png"),id:1,is_cover:false},
        //       { url: require("https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcproductimg/productin.png"),id:2,is_cover:false},
        //       { url: require("https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcproductimg/productin.png"),id:3,is_cover:false},
        //       { url: require("https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcproductimg/productin.png"),id:4,is_cover:false},
        //       { url: require("https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcproductimg/productin.png"),id:5,is_cover:false},
        // { url: require("https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcproductimg/productin.png"),id:6,is_cover:true},
        // { url: require("https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcproductimg/productin.png"),id:2,is_cover:false},
        // { url: require("https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcproductimg/productin.png"),id:3,is_cover:false},
        // { url: require("https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcproductimg/productin.png"),id:4,is_cover:false},
      ],
    }
  },
  components:{
    headers,
    footers
  },
  created() {

    this.getParams()
    this.pcchannelcategorylist()
    this.pcchannelcategoryidlist()
    this.heshow=true
    this.proarr()
  },
  watch:{
    '$route': 'getParams'
  },
  mounted() {
    document.addEventListener('scroll',this.handleScroll,false)
    this.$once('hook:beforeDestroy', () => {
      document.removeEventListener('scroll', this.handleScroll,false)
    })
    if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {

      this.$router.push({path:'./phproduct',query:{e:this.$route.query.e}})
    }

    sessionStorage.setItem('page',JSON.stringify({name:'pcproduct',data:false}))
  },
  methods: {
    changidpros(){

      /* for(let l =0;l<this.categorylistcontsecz.length;l++){
        if(l=0){

        }else{
          this.cargintproid=this.categorylistcontsecz[l].id

            let data={
                lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
                channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
                page:1,
                pageSize:5,
                category_id:this.cargintproid,
                mold:"pc",
              }
            this.$api.get_channel_category_id_list(data).then((res) => {

                this.lcategoryidlist=res.data
                let ccc=[]
                ccc.push(this.lcategoryidlist)

            });

        }

      } */
    },
    ChangeEmit(){ //子组件传递
      //主动调用子组件
      this.$refs.is_change.get_index_channel_data();
      this.$refs.is_change.pageParam();
      this.getParams()
      this.pcchannelcategorylist()
      this.pcchannelcategoryidlist()
      this.pageParam() //页面静态参数
    },
    proarr(){
      /* var arry= [{a:11,b:22,c:33,d:44},{a:11,b:0,c:0,d:44},{a:11,b:22,c:99,d:99}];
      var arry2=[];
      arry.map(((item, index)=> {
      arry2.push(Object.assign({},item,{mess1:33,mess2:44}))
      }))
       */
    },
    proconblock(e){
      /*  */
      for(let i =0;i<this.categorylistcontsecz.length;i++){
        if(this.categorylistcontsecz[i].id==e){
          if(this.categorylistcontsecz[i].mess1==true){
            this.categorylistcontsecz[i].mess1=false
          }else{
            this.categorylistcontsecz[i].mess1=true
          }
        }
      }
      /* this.procont=e */
    },
    pcchannelcategorylist(){
      let data={
        lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
        channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
      }
      this.$api.get_channel_category_list(data).then((res) => {


        this.categorylist=res.data
        this.categorylistcontsecz=[];
        this.categorylist.map(((item, index)=> {
          this.categorylistcontsecz.push(Object.assign({},item,{mess1:true,mess2:7}))
          this.active_category[item.id] = true
        }))
        this.changidpros()

        this.$refs.is_change.scrollIntoView('product_category'+this.$route.query.e)
        // console.log('sfadfsf',this.categorylistcontsecz);
        //初始化结果,每一项加一个jsShow=true
      });
    },
    pcchannelcategoryidlist(){
      let data={
        lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
        channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
        page:1,
        pageSize:10000000,
        category_id:0,
        mold:"pc",
      }
      this.$api.get_channel_category_id_list(data).then((res) => {

        this.lcategoryidlist=res.data

      });
    },
    handleScroll () {
      let scrollTop = document.documentElement.scrollTop ||document.body.scrollTop
      this.$refs.head.scrollTop_change(scrollTop)
    },
    nextimg(){
      let l = this.list_img.length;
      let scroll = document.getElementById('scroll-x');
      let diatance = scroll.scrollWidth - scroll.clientWidth;
      if(this.current_index == 0){
        this.current_index = l-1;
        scroll.scrollLeft = diatance;
      }else{
        this.current_index--;
        scroll.scrollLeft -= diatance / (l - 1);
      }
    },
    preimg(){
      console.log(11111)
      let l = this.list_img.length;
      let scroll = document.getElementById('scroll-x');
      let diatance = scroll.scrollWidth - scroll.clientWidth;
      if(this.current_index+1 == l){
        this.current_index = 0;
        scroll.scrollLeft = 0;
      }else{
        this.current_index++;
        scroll.scrollLeft += diatance / (l - 1);
      }
    },
    pageParam(){
      let lang =  session.get("lang");
      if (lang === "cn"){
        this.procenter = "产品中心"

      }else{
        this.procenter = "PRODUCTS"
      }
    },
    hometo(){
      this.$router.push({path: '/pchome'})
    },
    videoto(){
      this.$router.push({path: '/pcvideos'})
    },
    queryto(){
      this.$router.push({path: '/pcquerys'})
    },
    productto(){
      this.$router.push({path: '/pcproduct'})
    },
    elitesto(){
      this.$router.push({path: '/pcelites'})
    },
    contactusto(){
      this.$router.push({path: '/pccontactus'})
    },
    aboutto(){
      this.$router.push({path: '/pcabout'})
    },
    detailto(e){
      this.$router.push({path: '/pcdetails',query:{e,type:'pc'}})
    },
    seachto(){
      this.$router.push({path: '/pcseachs'})
    },
    enter(index){
      this.navheader= true;
    },
    playenterli(){
      this.playli=false
    },
    playenterri(){
      this.playri=false
    },
    playleaveli(){
      this.playli=true
    },
    playleaveri(){
      this.playri=true
    },
    getParams () {
      this.id = this.$route.query.e
      this.$refs.is_change.scrollIntoView('product_category'+this.$route.query.e)
    }

  }
}
</script>

<style>
body{
  margin: 0;
  padding: 0;
  background: #fff;
}
.pcproducts{
  width: calc(100vw);
  height: calc(100vh);
  /* overflow-x: hidden; */
  position: relative;
  background: #fff;
}
.pchome-headerpro{
  width: 100%;
  position: relative;
  background-size: 100% 100%;
  padding-top:119px;
  box-sizing: border-box;
}

.checse{
  margin-top: 0 !important;
}
.product-title{
  color: #fff;
  margin-top: 249px;
  margin-left: 240px;
}
.title-hea{
  font-size: 20px;
  font-weight: normal;
  letter-spacing: 1px;
}
.title-model{
  margin-top: 15px;
  margin-bottom: 15px;
  font-size: 44px;
  font-weight: normal;
  letter-spacing: 2px;
}
.product-but{
  margin-top: 40px;
  font-size: 16px;
  width: 110px;
  height: 46px;
  background: #E31E24;
  border-radius: 23px;
  line-height: 46px;
  text-align: center;
  cursor: pointer;
  font-size: 16px;
}
/* .header-nav{
  width: 1400px;
  height: 79px;
  display: flex;
  align-items: center;
  padding: 0 260px;
  position: fixed;
  top: 0;
} */
.nav-wit{

}
.nav-left{
  width: 100px;
  height: 50px;
}
.nav-left img{
  width: 100%;
  height: 100%;
}
/* .nav-center-item:hover{
  border-bottom: 2px solid #E31E24;
} */

.nav-center-item:first-child{
  margin-left: 0;
}
.nav-right{
  display: flex;
  align-items: center;
  color: #fff;
  font-size: 16px;
  font-weight: 400;
  margin-left: 180px;
}
.nav-right .search{
  display: flex;
  align-items: center;
  width: 20px;
  height: 20px;
  margin-right: 20px;
  cursor: pointer;
}
.nav-right .search img{
  width: 100%;
  height: 100%;
}
.nav-right .homename{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
  cursor: pointer;
}
.nav-right .homename img{
  width: 16px;
  height: 16px;
  margin-left: 4px;
}
.nav-right .language{
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.nav-right .language img{
  width: 16px;
  height: 16px;
  margin-left: 6px;
}

.bb{
  background: #FAFAFA;
  position: fixed;
  top: 0;
  z-index: 99;
}
.aboutitem-hea{
  margin-top: 80px;
  margin-bottom: 40px;
  height: 33px;
  font-size: 24px;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 33px;
  letter-spacing: 1px;
}
.aboutitem-fooitem{
  margin-bottom: 10px;
}
.fooitem-left{
  width: 110px;
  height: 32px;
  border-radius: 4px;
  border: 1px solid #EAEAEA;
  display: flex;
  align-items: center;
  justify-content: center;


  font-size: 16px;
  font-weight: 400;
  color: #FAFAFA;
  margin-right: 20px;
}
.fooitem-left img{
  width: 16px;
  height: 16px;
  margin-right: 6px;
}
.aboutitem-foosus{
  display: flex;
  margin-bottom: 20px;
}
.fooitem-right{
  font-size: 16px;
  font-weight: 400;
  color: #CCCCCC;
}
.fooitem-cont{
  margin-top: 25px;
  margin-left: 40px;
}
.fooitem-cont:first-child{
  margin-left: 0px;
}
.fooite-img{
  display: flex;
}
.fooite-img img{
  width: 90px;
  height: 90px;
}
.fooite-nam{
  text-align: center;
  margin-top: 20px;
}
.right-tit{
  margin-bottom: 5px;
}
.homefoot{

  height: 94px;
  background: #272727;
  border-top: 2px solid #666;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.foot-hea{
  height: 22px;
  font-size: 16px;
  font-weight: 400;
  color: #666666;
  line-height: 22px;
}
.foot-f{
  height: 22px;
  font-size: 16px;
  font-weight: 400;
  color: #666666;
  line-height: 22px;
  margin-top: 10px;
  margin-bottom: 20px;
}
.producthea{
  width: 1400px;
  height: 88px;
  font-size: 20px;
  display: flex;
  padding: 0 260px;
  justify-content: space-between;
  align-items: center;
}
.producthea-left{
  font-size: 28px;
  color: #5d5f5f;
}
.producthea-right{
  display: flex;

}

.producthea-righttitle{
  display: flex;
  font-size: 16px;
  flex-wrap: wrap;
  margin-left: -24px;
}
.producthearight-item{
  margin-left: 24px;
}
.producthearight-item:first-child{
  //margin-left: 0px;
}
.producthea-righticon{
  width: 16px;
  height: 16px;
  margin-left: 9px;
}
.producthea-righticon img{
  width: 100%;
  height: 100%;
}
.linesd{
  width: 1400px;
  height: 1px;
  background: #EAEAEA;
  margin: 0 auto;
}
.pcproducts .product-list-container {
  background-color: rgb(247,247,248);
}
.productfoo{
  width: 1400px;
  display: flex;
  flex-direction: column;
  padding: 0 260px;

}
.productfoo-down{
  cursor: pointer;
  color: #D03E3D;
  font-size: 16px;
  font-weight: 400;
  display: flex;
  align-items: center;
  margin-top: 24px;
}
.productfoo-down img{
  margin-right: 12px;
  width: 18px;
  height: 18px;
}
.productfoo-down div{
  margin-right: 12px;
  width: 18px;
  height: 18px;
  /* background: url(https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcproductimg/open.png) no-repeat;
  background-size: auto 100%; */

}
.productfoo-shop{
  display: flex;
  flex-wrap: wrap;
  margin-top: 24px;
  margin-left: -40px;

}
.shop-item:first-child .shopitem-img{
  width: 680px;
  height: 320px;
}
.shop-item:first-child .shopitem-img:hover img{
  width: 680px;
  height: 320px;
  transform: scale(1.02,1.02);
}
.shop-item:first-child  .shopitem-img img{
  width: 680px;
  height: 320px;
  transition: all .75s ease-in-out;
}
.shop-item{
  margin-left: 40px;
  margin-bottom: 60px;

}
.shopitem-img{
  width: 320px;
  height: 320px;
  border-radius: 22px;
  -webkit-border-radius:22px;
  -ms-border-radius:22px;
  -o-border-radius:22px;
  -moz-border-radius:22px;
  overflow: hidden;
  transform: rotate(0deg);
}
.shopitem-img img{
  width: 320px;
  height: 320px;
  transition: all .75s linear;
}
.shopitem-img:hover img{
  cursor: pointer;
  width: 320px;
  height: 320px;
  transform: scale(1.02,1.02);
  /* transform: scale(1.1); */
}
.shopitem-model{
  margin-top: 15px;
  font-size: 17px;
  color: #5d5f5f;
  font-weight: bold;
}
.shopitem-title{
  margin-top: 10px;
  font-size: 16px;
  font-weight: 500;
  color: #5d5f5f;
}

.ac{
  display: none;
}
</style>
